import { render, staticRenderFns } from "./Stockists.vue?vue&type=template&id=62ca4b11&scoped=true&lang=pug&"
import script from "./Stockists.vue?vue&type=script&lang=js&"
export * from "./Stockists.vue?vue&type=script&lang=js&"
import style0 from "./Stockists.vue?vue&type=style&index=0&id=62ca4b11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca4b11",
  null
  
)

export default component.exports